// test2051
(2051 && 0);
